import NotionAccounts from './NotionAccounts'

export default NotionAccounts
